<template lang="html">
  <div class="mh4 mt4">
    <div class="row w-100 middle-xs between-xs">
      <!-- <pl-button
        @click.native="goToBack"
        :disabled="screenActive === 2"
        style="margin: 0; padding: 0;"
      >
        <span
          class="back-btn truncate-text"
          :class="screenActive === 2 ? 'disabled_back' : ''"
        >
          <i class="fa fa-arrow-left"></i>
          Back
        </span>
      </pl-button> -->
      <div v-if="users_tab === 'admin-add-users'" class="add-users-title">
        Add users to your organization
      </div>
      <div v-else class="add-users-title">Add courses to your organization</div>
      <pl-button
        v-if="screenActive < 2"
        :class="nextStep ? 'pl-primary' : 'disabled'"
        :disabled="!nextStep"
        style="font-size: 16px; font-weight: 550"
        @click.native="nextScreen"
      >
        IMPORT
      </pl-button>
    </div>
    <div class="row col-xs center-xs middle-xs">
      <!-- <div class="w-100"> -->

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        screenActive: 0,
        nextStep: false,
        usersToAdd: [],
        coursesToAdd: [],
        send_email: false,
        job_state: 'active',
      };
    },
    props: {
      stepActive: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
      users_tab() {
        if (this.$route.name === 'admin-add-users') {
          return this.$route.name;
        }
        return 'admin-add-courses';
      },
    },
    methods: {
      async nextScreen() {
        const schoolID = this.$route.params.schoolID;
        this.$emit('nextScreen', this.screenActive + 1);
        if (this.screenActive === 1) {
          let usersData = [];
          if (this.users_tab === 'admin-add-users') {
            this.usersToAdd.forEach((user) => {
              const userInfo = {
                name: user.name.value,
                email: user.email.value,
                role: user.role.value,
                site: user.site.value,
              };

              usersData.push(userInfo);
            });
            const res = await adminServices.addUsersJob(schoolID, {
              send_emails: this.send_email,
              users: usersData,
            });
            if (res.data.id) {
              EventBus.$emit('loadingUsersOrCourses', true);
              let state = '';
              let result = '';
              let reason = '';
              do {
                await this.sleep(1000);
                const response = await adminServices.getUsersJobResponse(
                  schoolID,
                  res.data.id
                );
                state = response.data.state;
                result = response.data.result;
                reason = response.data.reason;
              } while (state !== 'completed' && state !== 'failed');
              if (state === 'completed') {
                EventBus.$emit('loadingUsersOrCourses', false);
                EventBus.$emit('summaryUsersAdded', result);
              } else if (state === 'failed') {
                EventBus.$emit('loadingUsersOrCourses', false);
                this.$router.push({
                  name: 'admin-users',
                });
                EventBus.$emit(
                  'toast-msg',
                  `An error has occurred while importing users. - ${reason}`
                );
              }
            }
          } else {
            this.coursesToAdd.forEach((course) => {
              let array_co_teachers = [];
              let array_students = [];

              if (course.co_teachers.value) {
                course.co_teachers.value.split(';').map((co_teacher) => {
                  array_co_teachers.push(co_teacher.trim());
                });
              }
              if (course.students.value) {
                course.students.value.split(';').map((student) => {
                  array_students.push(student.trim());
                });
              }

              const courseInfo = {
                course_name: course.course_name.value,
                section: course.section.value,
                teacher: course.teacher.value,
                co_teachers: array_co_teachers,
                students: array_students,
              };
              usersData.push(courseInfo);
            });

            const res = await adminServices.addCoursesJob(schoolID, usersData);
            if (res.data.id) {
              EventBus.$emit('loadingUsersOrCourses', true);
              let state = '';
              let result = '';
              let reason = '';
              do {
                await this.sleep(1000);
                const response = await adminServices.getCoursesJobResponse(
                  schoolID,
                  res.data.id
                );
                state = response.data.state;
                result = response.data.result;
                reason = response.data.reason;
              } while (state !== 'completed' && state !== 'failed');

              if (state === 'completed') {
                EventBus.$emit('summaryCoursesAdded', result);
                EventBus.$emit('loadingUsersOrCourses', false);
              } else if (state === 'failed') {
                EventBus.$emit('loadingUsersOrCourses', false);
                this.$router.push({
                  name: 'admin-courses',
                });
                EventBus.$emit(
                  'toast-msg',
                  `An error has occurred while importing courses. - ${reason}`
                );
              }
            }
          }
        }
        this.screenActive = this.screenActive + 1;
        this.nextStep = false;
      },
      goToBack() {
        if (this.screenActive === 1) {
          const name =
            this.users_tab === 'admin-add-users'
              ? 'admin-users'
              : 'admin-courses';
          return this.$router.push({
            name,
          });
        }
        this.$emit('nextScreen', this.screenActive - 1);
        this.screenActive = this.screenActive - 1;
      },
      sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
    },
    mounted() {
      this.screenActive = this.stepActive + 1;
      EventBus.$on('activeNext', (next) => {
        this.nextStep = next;
      });

      EventBus.$on('saveUsers', (users, email_notification) => {
        this.usersToAdd = users;
        this.send_email = email_notification;
      });

      EventBus.$on('saveCourses', (courses) => (this.coursesToAdd = courses));

      EventBus.$on('reloadAddUsers', () => (this.screenActive = 1));

      EventBus.$on('reloadAddCourses', () => (this.screenActive = 1));

      EventBus.$on('nextStep', () => (this.screenActive = 2));
    },
    beforeDestroy() {
      EventBus.$off('activeNext');
      EventBus.$off('saveUsers');
      EventBus.$off('reloadAddUsers');
      EventBus.$off('saveCourses');
      EventBus.$off('reloadAddCourses');
      EventBus.$off('nextStep');
    },
  };
</script>

<style lang="stylus" scoped>
    @import '~app/global-stylus.styl';

    .add-users-title
      color: #273248
      font-size: 20px
      font-weight: 700

    .back-btn
      color: #273248
      font-size: 20px
      font-weight: 600

    .disabled_back
      color: silver !important

  ol.progress[data-steps="2"] li { width: 49%; }
  ol.progress[data-steps="3"] li { width: 33%; }
  ol.progress[data-steps="4"] li { width: 24%; }
  ol.progress[data-steps="5"] li { width: 19%; }
  ol.progress[data-steps="6"] li { width: 16%; }
  ol.progress[data-steps="7"] li { width: 14%; }
  ol.progress[data-steps="8"] li { width: 12%; }
  ol.progress[data-steps="9"] li { width: 11%; }

  .progress {
    width: 50%
    list-style: none
    list-style-image: none
    padding: 0
  }

  .progress li {
    float: left;
    text-align: center;
    position: relative;
  }

  .progress .name {
    display: block;
    vertical-align: bottom;
    text-align: center;
    font-size: 12px
    margin-bottom: -1em;
    color: black;
    opacity: 0.3;
    font-weight: 600
  }

  .progress .step {
    color: black;
    border: 3px solid silver;
    background-color: silver;
    border-radius: 50%;
    line-height: 0.8;
    width: 1.5em;
    height: 1.5em;
    display: inline-block;
    z-index: 0;
  }

  .progress .step span {
    opacity: 0.3;
  }

  .progress .active .name,
  .progress .active .step span {
      opacity: 1;
  }

  .progress .done .name,
  .progress .done .step span {
      opacity: 1;
  }

  .progress .step:before {
      content: "";
      display: block;
      background-color: silver;
      height: 0.2em;
      width: 50%;
      position: absolute;
      bottom: 1.5em;
      left: 0;
      z-index: -1;
  }

  .progress .step:after {
      content: "";
      display: block;
      background-color: silver;
      height: 0.2em;
      width: 50%;
      position: absolute;
      bottom: 1.5em;
      right: 0;
      z-index: -1;
  }

  .progress li:first-of-type .step:before {
      display: none;
  }

  .progress li:last-of-type .step:after {
      display: none;
  }

  .progress .done .step,
  .progress .done .step:before,
  .progress .done .step:after,
  .progress .active .step,
  .progress .active .step:before {
      background-color: black;
  }

  .progress .done .step,
  .progress .active .step {
      border: 3px solid black;
  }
</style>



// WEBPACK FOOTER //
// addUsersStepsBar.vue?2bc544ea